module.exports = __webpack_public_path__ + "static/reward_bg.1458133d.png";